import { FilterCompanyLicensesWebPage, getCompanyLicensesWebPage } from 'commons/service/bank/companyDetails'
import { CompanyLicensesWebPage } from 'commons/types/DTO/bank/companyDetails/license'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyLicensesWebPage: WriteHook<FilterCompanyLicensesWebPage, CompanyLicensesWebPage> = (
  opts
) => useMutationManager(getCompanyLicensesWebPage, opts)
